module.exports = __webpack_public_path__ + "static/images/biffy_win.583c0bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biffy_win.png
// module id = +D9K
// module chunks = 1